import FormGroupRenderer, {
  ILabelColumnSize,
} from '@app/components/FormGroupRenderer'
import { IRaceEthnicityBreakdown } from '@app/models/RaceEthnicityBreakdown'
import { formatNumber } from '@app/utils/formatting'
import * as React from 'react'

interface IRaceEthnicityBreakdownProps {
  className?: string
  raceEthnicityBreakdown: IRaceEthnicityBreakdown
  style?: React.CSSProperties
}

export default class RaceEthnicityBreakdownView extends React.PureComponent<
  IRaceEthnicityBreakdownProps
> {
  public render() {
    const raceEthnicityBreakdown = this.props.raceEthnicityBreakdown
    const labelColSizes: ILabelColumnSize = {
      md: 6,
    }

    return (
      <div className={this.props.className} style={this.props.style}>
        {raceEthnicityBreakdown.raceEthnicities
          .sortBy((r) => (r !== undefined ? -r.percentage : undefined))
          .toArray()
          .map((raceEthnicity, i) => (
            <FormGroupRenderer
              className='mb-0'
              key={`race-ethnicity-${i}`}
              labelColSizes={labelColSizes}
              labelText={raceEthnicity.description}
            >
              {formatNumber(raceEthnicity.percentage, 1)} %
            </FormGroupRenderer>
          ))}
        {raceEthnicityBreakdown.otherPercentage > 0 && (
          <FormGroupRenderer
            className='mb-0'
            labelColSizes={labelColSizes}
            labelText='Other'
          >
            {formatNumber(raceEthnicityBreakdown.otherPercentage, 1)} %
          </FormGroupRenderer>
        )}
        <div className='small'>
          Percentage of total population in {raceEthnicityBreakdown.year}
        </div>
      </div>
    )
  }
}
